//@ts-nocheck
import React from "react";

import { css } from "@compiled/react";

import Avatar, { AvatarItem } from "@atlaskit/avatar";
import { fontFamily } from "@atlaskit/theme";

import { getInitials } from "../utils/initials";

export type AccountDetailsProps = {
    readonly userName: string;
    readonly userEmail: string;
    readonly avatarSrc?: string;
};

const AccountDetails = ({
    userName,
    userEmail,
    avatarSrc
}: AccountDetailsProps) => (
    <AvatarItem
        avatar={
            avatarSrc !== undefined ? (
                <Avatar src={avatarSrc} />
            ) : (
                <div css={initialsContainerStyle}>
                    <span css={initialsStyle}>{getInitials(userName)}</span>
                </div>
            )
        }
        key={userEmail}
        primaryText={userName}
        secondaryText={userEmail}
    />
);

const initialsStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    fontFamily: fontFamily,
    fontSize: "10px",
    lineHeight: "10px",
    color: "#42526e", // N500

    width: "100%",
    height: "100%",
    backgroundColor: "#dfe1e5", // N40
    borderRadius: "50%"
});

const initialsContainerStyle = css({
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#dfe1e5" // N40
});

export default AccountDetails;
